/* GOPSHOP – „Das könnte dir auch gefallen“ (sections/related-products.liquid)
   1) Bento-Karten: Bild passend einpassen (bei stark abweichendem Format ganz zeigen über unscharfer Kopie),
      Neigen + Glanz mit der Maus, Druck-Feedback am Handy, Produktdaten beim Zeigen vorladen.
   2) Schnellansicht: Handy = Glas-Blatt von unten (nach unten wischen schließt), Desktop = Fenster in der Mitte.
      Galerie (wischbar), Varianten (Pillen oder Bild-Kacheln), Menge, „In den Warenkorb“ (/cart/add.js),
      danach Warenkorb-Hinweis des Themes (renderContents) bzw. Zähler im Kopf aktualisieren.
      Daten: /products/<handle>.js. Dialog mit Fokusfalle, Esc, Fokus zurück, Seite gesperrt ohne Springen.
   Shopify lädt die Empfehlungen per AJAX nach → Start per MutationObserver (+ shopify:section:load). */
(function () {
  'use strict';
  if (window.__gopRel2) return;
  window.__gopRel2 = true;

  var EN = /^en/i.test(document.documentElement.lang || '');
  var T = EN
    ? {
        close: 'Close',
        dialog: 'Quick view',
        gallery: 'Product images',
        slide: 'image',
        imgOf: function (i, n) {
          return 'Image ' + i + ' of ' + n;
        },
        prev: 'Previous image',
        next: 'Next image',
        add: 'Add to cart',
        adding: 'Adding…',
        added: 'Added',
        soldOut: 'Sold out',
        unavailable: 'Unavailable',
        choose: 'Choose an option',
        qty: 'Quantity',
        less: 'Decrease quantity',
        more: 'Increase quantity',
        details: 'View all details',
        inCart: 'Added to your cart.',
        toCart: 'View cart',
        error: 'That didn’t work. Please try again.',
        loadError: 'Couldn’t load the product.',
        from: 'from',
        was: 'Regular price',
        out: 'sold out',
      }
    : {
        close: 'Schließen',
        dialog: 'Schnellansicht',
        gallery: 'Produktbilder',
        slide: 'Bild',
        imgOf: function (i, n) {
          return 'Bild ' + i + ' von ' + n;
        },
        prev: 'Vorheriges Bild',
        next: 'Nächstes Bild',
        add: 'In den Warenkorb',
        adding: 'Wird hinzugefügt …',
        added: 'Hinzugefügt',
        soldOut: 'Ausverkauft',
        unavailable: 'Nicht verfügbar',
        choose: 'Bitte wählen',
        qty: 'Menge',
        less: 'Menge verringern',
        more: 'Menge erhöhen',
        details: 'Alle Details ansehen',
        inCart: 'Im Warenkorb.',
        toCart: 'Zum Warenkorb',
        error: 'Das hat nicht geklappt. Bitte versuche es noch einmal.',
        loadError: 'Produkt konnte nicht geladen werden.',
        from: 'ab',
        was: 'Statt',
        out: 'ausverkauft',
      };

  var mm = function (q) {
    return window.matchMedia ? window.matchMedia(q) : { matches: false };
  };
  var mqReduce = mm('(prefers-reduced-motion: reduce)');
  var mqFine = mm('(hover: hover) and (pointer: fine)');
  var mqSheet = mm('(max-width: 749px)');

  /* wie gop-product.js: Größen bleiben Pillen, Modell/Farbe/Duft … mit Variantenbildern werden Kacheln */
  var SIZE_RX = /gr(ö|oe)(ß|ss)e|size|taille|tama|menge|volumen|anzahl|quantity|länge|length|breite|width|^ml$|^inhalt \(ml\)$/i;
  var TILE_RX = /modell|model|modelo|mod[eè]le|duft|scent|fragrance|parfum|design|style|stil|variante|variant|motiv|sorte|edition|ausf[üu]hrung|typ|type|version|farbe|color|colou?r|couleur|colore|kollektion|collection|look/i;

  var SVG = {
    x: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>',
    minus: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    ok: '<svg class="gqv__ok" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  };

  /* ---------- Hilfen ---------- */
  function makeMoney(raw) {
    var ta = document.createElement('textarea');
    ta.innerHTML = String(raw || '');
    var sample = ta.value;
    var run = (sample.match(/\d[\d.,'’\s]*\d/) || [])[0];
    if (!run) {
      return function (c) {
        return (c / 100).toFixed(2);
      };
    }
    var seps = run.replace(/\d/g, '');
    var groups = run.split(/\D+/);
    var last = groups[groups.length - 1];
    var dec = '';
    var thou = '';
    var decimals = 0;
    if (groups.length > 1 && last.length === 2) {
      decimals = 2;
      dec = seps[seps.length - 1];
      thou = seps.length > 1 ? seps[0] : '';
    } else if (groups.length > 1) {
      thou = seps[0];
    }
    var i = sample.indexOf(run);
    var pre = sample.slice(0, i);
    var post = sample.slice(i + run.length);
    return function (cents) {
      var v = decimals ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
      var parts = v.split('.');
      var int = parts[0];
      if (thou) int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return pre + (parts[1] ? int + dec + parts[1] : int) + post;
    };
  }

  function imgUrl(src, w) {
    if (!src) return '';
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function srcset(src, maxW) {
    return [360, 540, 720, 900, 1080, 1440]
      .filter(function (w, k) {
        return !maxW || w <= maxW || k === 0;
      })
      .map(function (w) {
        return imgUrl(src, w) + ' ' + w + 'w';
      })
      .join(', ');
  }

  function initials(v) {
    return String(v)
      .replace(/\(.*?\)/g, ' ')
      .split(/[\s\-–/]+/)
      .filter(function (w) {
        return /[a-z0-9]/i.test(w);
      })
      .slice(0, 2)
      .map(function (w) {
        return w[0].toUpperCase();
      })
      .join('');
  }

  function rootPath(root) {
    var r = (root && root.getAttribute('data-root')) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  var cache = {};
  function getJson(u) {
    return fetch(u, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  /* Produktdaten (einmal pro Seite; bei Netzfehler ein zweiter Versuch) */
  function loadProduct(root, handle) {
    var u = rootPath(root) + 'products/' + encodeURIComponent(handle) + '.js';
    if (!cache[u]) {
      cache[u] = getJson(u)
        .catch(function () {
          return new Promise(function (res) {
            setTimeout(res, 1200);
          }).then(function () {
            return getJson(u);
          });
        })
        .catch(function (e) {
          delete cache[u];
          throw e;
        });
    }
    return cache[u];
  }

  function noCompare(p) {
    if (/mystery-box/i.test(p.handle || '')) return true;
    return (p.tags || []).some(function (t) {
      return String(t).toLowerCase() === 'kein-streichpreis';
    });
  }

  /* =====================================================================
     1) Karten
     ===================================================================== */
  function fitCards(root) {
    var list = root.querySelectorAll('.gpr2-card__media[data-ar]');
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      var ar = parseFloat(m.getAttribute('data-ar')) || 1;
      var w = m.clientWidth;
      var h = m.clientHeight;
      if (!w || !h) continue;
      fitBox(m, ar, w / h, 1.45);
    }
  }

  /* Format stark anders als der Rahmen → ganz zeigen (is-tall = schmaler, is-wide = breiter als der Rahmen) */
  function fitBox(el, ar, box, limit) {
    var q = ar > box ? ar / box : box / ar;
    var on = q > limit;
    el.classList.toggle('is-contain', on);
    el.classList.toggle('is-tall', on && ar < box);
    el.classList.toggle('is-wide', on && ar >= box);
  }

  function initCard(card, root) {
    var link = card.querySelector('[data-gpr2-open]');
    if (!link) return;
    var handle = card.getAttribute('data-handle');
    var pre = function () {
      loadProduct(root, handle).catch(function () {});
    };
    card.addEventListener('pointerenter', pre, { once: true });
    card.addEventListener('focusin', pre, { once: true });
    card.addEventListener('touchstart', pre, { once: true, passive: true });

    link.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      QV.open(card, root, link);
    });

    /* Druck-Feedback (Finger/Stift) */
    var unpress = function () {
      card.classList.remove('is-press');
    };
    card.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      if (e.target.closest && e.target.closest('.gpr2-card__details')) return;
      card.classList.add('is-press');
    });
    card.addEventListener('pointerup', unpress);
    card.addEventListener('pointercancel', unpress);
    card.addEventListener('pointerleave', unpress);

    /* Neigen + Glanz (nur Maus) */
    var shine = card.querySelector('.gpr2-card__shine');
    var rect = null;
    var raf = 0;
    var px = 0;
    var py = 0;
    var paint = function () {
      raf = 0;
      if (!rect) return;
      var max = card.classList.contains('gpr2-card--hero') ? 2.2 : 4.2;
      card.style.transform =
        'perspective(1100px) rotateX(' + (-py * max).toFixed(2) + 'deg) rotateY(' + (px * max).toFixed(2) + 'deg) translate3d(0,-3px,0)';
      if (shine) {
        shine.style.setProperty('--sx', (px * 60).toFixed(1) + '%');
        shine.style.setProperty('--sy', (py * 60).toFixed(1) + '%');
      }
    };
    card.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !mqFine.matches || mqReduce.matches) return;
      rect = card.getBoundingClientRect();
      card.classList.add('is-tilt');
    });
    card.addEventListener('pointermove', function (e) {
      if (!rect || e.pointerType !== 'mouse') return;
      px = Math.max(-0.5, Math.min(0.5, (e.clientX - rect.left) / rect.width - 0.5));
      py = Math.max(-0.5, Math.min(0.5, (e.clientY - rect.top) / rect.height - 0.5));
      if (!raf) raf = requestAnimationFrame(paint);
    });
    card.addEventListener('pointerleave', function () {
      if (!rect) return;
      rect = null;
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
      card.classList.remove('is-tilt');
      card.style.transform = '';
    });
    window.addEventListener(
      'scroll',
      function () {
        if (rect) rect = card.getBoundingClientRect();
      },
      { passive: true }
    );
  }

  function initRoot(root) {
    if (root.__gpr2) return;
    root.__gpr2 = true;
    /* Karten gestaffelt einblenden, wenn sie ins Bild kommen (ohne Script: sofort sichtbar) */
    if ('IntersectionObserver' in window && !mqReduce.matches) {
      var r0 = root.getBoundingClientRect();
      if (r0.top > window.innerHeight * 0.9) {
        root.classList.add('is-wait');
        var io = new IntersectionObserver(
          function (en) {
            if (!en[0].isIntersecting) return;
            io.disconnect();
            root.classList.remove('is-wait');
            root.classList.add('is-in');
          },
          { rootMargin: '0px 0px -12% 0px' }
        );
        io.observe(root);
      } else if (r0.bottom > 0) {
        root.classList.add('is-in');
      }
    }
    var cards = root.querySelectorAll('[data-gpr2-card]');
    for (var i = 0; i < cards.length; i++) initCard(cards[i], root);
    fitCards(root);
    if ('ResizeObserver' in window) {
      var t = 0;
      new ResizeObserver(function () {
        if (t) return;
        t = requestAnimationFrame(function () {
          t = 0;
          fitCards(root);
        });
      }).observe(root);
    } else {
      window.addEventListener('resize', function () {
        fitCards(root);
      });
    }
  }

  function scan(scope) {
    var list = (scope || document).querySelectorAll('[data-gpr2]');
    for (var i = 0; i < list.length; i++) initRoot(list[i]);
  }

  function watch() {
    var recs = document.querySelectorAll('product-recommendations.gpr2__rec');
    for (var i = 0; i < recs.length; i++) {
      var el = recs[i];
      if (el.__gpr2w) continue;
      el.__gpr2w = true;
      (function (rec) {
        if ('MutationObserver' in window) {
          new MutationObserver(function () {
            scan(rec);
          }).observe(rec, { childList: true });
        }
        scan(rec);
      })(el);
    }
    scan(document);
  }

  /* =====================================================================
     2) Schnellansicht
     ===================================================================== */
  var QV = (function () {
    var el;
    var panel;
    var backdrop;
    var scroller;
    var gal;
    var track;
    var dotsEl;
    var prevB;
    var nextB;
    var titleEl;
    var priceEl;
    var optsEl;
    var moreA;
    var form;
    var qtyIn;
    var qMinus;
    var qPlus;
    var addB;
    var addT;
    var msgEl;
    var st = null; /* aktueller Zustand */
    var isOpen = false;
    var inerted = [];
    var hideT = 0;
    var doneT = 0;
    var pendingCart = null;
    var slideIdx = 0;
    var scrollRaf = 0;
    var touch = null;

    function build() {
      el = document.createElement('div');
      el.className = 'gqv';
      el.hidden = true;
      el.innerHTML =
        '<div class="gqv__backdrop" data-gqv-close></div>' +
        '<div class="gqv__panel" role="dialog" aria-modal="true" aria-labelledby="GqvTitle" tabindex="-1">' +
        '<div class="gqv__grab" aria-hidden="true"><i></i></div>' +
        '<button type="button" class="gqv__x" data-gqv-close aria-label="' + T.close + '">' + SVG.x + '</button>' +
        '<div class="gqv__scroll">' +
        '<div class="gqv__gal">' +
        '<div class="gqv__track" tabindex="0" role="region" aria-label="' + T.gallery + '"></div>' +
        '<button type="button" class="gqv__nav gqv__nav--prev" aria-label="' + T.prev + '">' + SVG.prev + '</button>' +
        '<button type="button" class="gqv__nav gqv__nav--next" aria-label="' + T.next + '">' + SVG.next + '</button>' +
        '<div class="gqv__dots"></div>' +
        '</div>' +
        '<div class="gqv__info">' +
        '<h2 class="gqv__title" id="GqvTitle"></h2>' +
        '<p class="gqv__price"></p>' +
        '<div class="gqv__opts"></div>' +
        '<a class="gqv__more" href="#">' + T.details + SVG.arrow + '</a>' +
        '</div>' +
        '</div>' +
        '<form class="gqv__buy" novalidate>' +
        '<div class="gqv__qty">' +
        '<button type="button" class="gqv__qbtn" data-q="-1" aria-label="' + T.less + '">' + SVG.minus + '</button>' +
        '<input class="gqv__qin" type="number" inputmode="numeric" min="1" value="1" aria-label="' + T.qty + '">' +
        '<button type="button" class="gqv__qbtn" data-q="1" aria-label="' + T.more + '">' + SVG.plus + '</button>' +
        '</div>' +
        '<button type="submit" class="gqv__add"><span class="gqv__spin" aria-hidden="true"></span>' + SVG.ok + '<span class="gqv__addt">' + T.add + '</span></button>' +
        '<p class="gqv__msg" role="status" aria-live="polite"></p>' +
        '</form>' +
        '</div>';
      document.body.appendChild(el);
      panel = el.querySelector('.gqv__panel');
      backdrop = el.querySelector('.gqv__backdrop');
      scroller = el.querySelector('.gqv__scroll');
      gal = el.querySelector('.gqv__gal');
      track = el.querySelector('.gqv__track');
      dotsEl = el.querySelector('.gqv__dots');
      prevB = el.querySelector('.gqv__nav--prev');
      nextB = el.querySelector('.gqv__nav--next');
      titleEl = el.querySelector('.gqv__title');
      priceEl = el.querySelector('.gqv__price');
      optsEl = el.querySelector('.gqv__opts');
      moreA = el.querySelector('.gqv__more');
      form = el.querySelector('.gqv__buy');
      qtyIn = el.querySelector('.gqv__qin');
      qMinus = el.querySelector('[data-q="-1"]');
      qPlus = el.querySelector('[data-q="1"]');
      addB = el.querySelector('.gqv__add');
      addT = el.querySelector('.gqv__addt');
      msgEl = el.querySelector('.gqv__msg');

      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-gqv-close]')) close();
      });
      prevB.addEventListener('click', function () {
        goSlide(slideIdx - 1, true);
      });
      nextB.addEventListener('click', function () {
        goSlide(slideIdx + 1, true);
      });
      dotsEl.addEventListener('click', function (e) {
        var b = e.target.closest('.gqv__dot');
        if (b) goSlide(parseInt(b.getAttribute('data-i'), 10) || 0, true);
      });
      track.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          var w = track.clientWidth || 1;
          setSlide(Math.round(track.scrollLeft / w));
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          goSlide(slideIdx + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      optsEl.addEventListener('change', function (e) {
        var input = e.target;
        if (!st || !st.product || !input.classList.contains('gqv__radio')) return;
        st.sel[parseInt(input.getAttribute('data-oi'), 10)] = input.value;
        update(true);
      });
      qMinus.addEventListener('click', function () {
        stepQty(-1);
      });
      qPlus.addEventListener('click', function () {
        stepQty(1);
      });
      qtyIn.addEventListener('change', function () {
        setQty(parseInt(qtyIn.value, 10));
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submit();
      });
      el.addEventListener('keydown', onKey);
      bindSwipe();
    }

    /* ---------- Öffnen / Schließen ---------- */
    function lock() {
      var de = document.documentElement;
      var sbw = window.innerWidth - de.clientWidth;
      de.classList.add('gqv-lock');
      if (sbw > 0) {
        if (window.CSS && CSS.supports && CSS.supports('scrollbar-gutter', 'stable')) de.classList.add('gqv-gutter');
        else document.body.style.paddingRight = sbw + 'px';
      }
    }
    function unlock() {
      var de = document.documentElement;
      de.classList.remove('gqv-lock', 'gqv-gutter');
      document.body.style.paddingRight = '';
    }
    function setInert(on) {
      if (on) {
        inerted = [];
        var kids = document.body.children;
        for (var i = 0; i < kids.length; i++) {
          var k = kids[i];
          if (k === el || k.inert || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(k.tagName)) continue;
          k.inert = true;
          inerted.push(k);
        }
      } else {
        inerted.forEach(function (k) {
          k.inert = false;
        });
        inerted = [];
      }
    }

    function open(card, root, opener) {
      if (!el) build();
      clearTimeout(hideT);
      clearTimeout(doneT);
      var handle = card.getAttribute('data-handle');
      st = {
        handle: handle,
        root: root,
        card: card,
        opener: opener,
        money: makeMoney(root.getAttribute('data-money')),
        product: null,
        variant: null,
        sel: [],
        media: [],
      };
      /* sofort: Titel, Preis und Bild der Karte – Rest folgt, sobald die Daten da sind */
      titleEl.textContent = card.getAttribute('data-title') || '';
      var cp = card.querySelector('.gpr2-card__price');
      priceEl.innerHTML = cp ? cp.innerHTML : '';
      moreA.href = opener.getAttribute('href');
      optsEl.innerHTML = '<div class="gqv__skel"></div><div class="gqv__skel"></div>';
      msgEl.textContent = '';
      msgEl.classList.remove('is-err');
      qtyIn.value = '1';
      setAdd('busy-init');
      var im = card.querySelector('.gpr2-card__img');
      var ar = parseFloat((card.querySelector('.gpr2-card__media') || card).getAttribute('data-ar')) || 1;
      buildGallery(im ? [{ id: 0, src: im.currentSrc || im.getAttribute('src'), alt: '', ar: ar, quick: true }] : []);

      lock();
      setInert(true);
      el.hidden = false;
      panel.style.transform = '';
      backdrop.style.opacity = '';
      void panel.offsetWidth;
      el.classList.add('is-open');
      isOpen = true;
      panel.focus({ preventScroll: true });
      fitGallery();

      loadProduct(root, handle).then(
        function (p) {
          if (!st || st.handle !== handle || !isOpen) return;
          render(p);
        },
        function () {
          if (!st || st.handle !== handle) return;
          optsEl.innerHTML = '';
          showMsg(T.loadError, true);
          setAdd('off', T.unavailable);
        }
      );
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      clearTimeout(doneT);
      el.classList.remove('is-open');
      panel.classList.remove('is-drag');
      panel.style.transform = '';
      backdrop.style.opacity = '';
      setInert(false);
      var opener = st && st.opener;
      var dur = mqReduce.matches ? 20 : mqSheet.matches ? 480 : 380;
      hideT = setTimeout(function () {
        el.hidden = true;
        unlock();
        if (pendingCart) {
          var pc = pendingCart;
          pendingCart = null;
          showCart(pc, opener);
        }
      }, dur);
      if (opener && document.contains(opener)) {
        try {
          opener.focus({ preventScroll: true });
        } catch (e) {}
      }
    }

    function onKey(e) {
      if (!isOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
        function (n) {
          return n.offsetWidth || n.offsetHeight || n.getClientRects().length;
        }
      );
      /* Radios einer Gruppe: nur das gewählte zählt */
      f = f.filter(function (n) {
        return !(n.type === 'radio' && !n.checked && panel.querySelector('input[name="' + n.name + '"]:checked'));
      });
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      var a = document.activeElement;
      if (e.shiftKey && (a === first || a === panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && a === last) {
        e.preventDefault();
        first.focus();
      }
    }

    /* ---------- Nach unten wischen schließt (Handy) ---------- */
    function bindSwipe() {
      panel.addEventListener(
        'touchstart',
        function (e) {
          if (!mqSheet.matches || e.touches.length !== 1) {
            touch = null;
            return;
          }
          var t = e.touches[0];
          var onGrab = !!(e.target.closest && e.target.closest('.gqv__grab'));
          var inScroll = scroller.contains(e.target);
          touch = { x: t.clientX, y: t.clientY, t0: e.timeStamp, mode: null, dy: 0, lastY: t.clientY, lastT: e.timeStamp, v: 0, grab: onGrab || !inScroll };
        },
        { passive: true }
      );
      panel.addEventListener(
        'touchmove',
        function (e) {
          if (!touch) return;
          var t = e.touches[0];
          var dx = t.clientX - touch.x;
          var dy = t.clientY - touch.y;
          if (!touch.mode) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            if (Math.abs(dx) > Math.abs(dy) && !touch.grab) {
              touch.mode = 'x';
              return;
            }
            touch.mode = dy > 0 && (touch.grab || scroller.scrollTop <= 0) ? 'drag' : 'scroll';
            if (touch.mode === 'drag') panel.classList.add('is-drag');
          }
          if (touch.mode !== 'drag') return;
          if (e.cancelable) e.preventDefault();
          var dt = Math.max(1, e.timeStamp - touch.lastT);
          touch.v = (t.clientY - touch.lastY) / dt;
          touch.lastY = t.clientY;
          touch.lastT = e.timeStamp;
          touch.dy = dy > 0 ? dy : dy / 4;
          panel.style.transform = 'translate3d(0,' + touch.dy.toFixed(1) + 'px,0)';
          backdrop.style.opacity = String(Math.max(0.25, 1 - Math.max(0, touch.dy) / (panel.offsetHeight || 600)));
        },
        { passive: false }
      );
      var end = function () {
        if (!touch) return;
        var tc = touch;
        touch = null;
        if (tc.mode !== 'drag') return;
        panel.classList.remove('is-drag');
        var h = panel.offsetHeight || 600;
        if (tc.dy > Math.min(140, h * 0.25) || (tc.v > 0.55 && tc.dy > 30)) {
          close();
        } else {
          panel.style.transform = '';
          backdrop.style.opacity = '';
        }
      };
      panel.addEventListener('touchend', end);
      panel.addEventListener('touchcancel', end);
    }

    /* ---------- Galerie ---------- */
    function mediaList(p) {
      var out = [];
      (p.media || []).forEach(function (m) {
        var pi = m.preview_image || {};
        var src = m.media_type === 'image' ? m.src || pi.src : pi.src;
        if (!src) return;
        var ar = m.aspect_ratio || pi.aspect_ratio || (pi.width && pi.height ? pi.width / pi.height : 1);
        out.push({ id: m.id, src: src, alt: m.alt || '', ar: ar, w: m.width || pi.width || 0 });
      });
      if (!out.length && p.featured_image) out.push({ id: 0, src: p.featured_image, alt: '', ar: 1 });
      return out;
    }

    function buildGallery(list) {
      st.media = list;
      track.innerHTML = '';
      dotsEl.innerHTML = '';
      list.forEach(function (m, i) {
        var s = document.createElement('div');
        s.className = 'gqv__slide';
        s.setAttribute('role', 'group');
        s.setAttribute('aria-roledescription', T.slide);
        s.setAttribute('aria-label', T.imgOf(i + 1, list.length));
        s.setAttribute('data-ar', m.ar || 1);
        var bg = document.createElement('img');
        bg.className = 'gqv__sbg';
        bg.alt = '';
        bg.setAttribute('aria-hidden', 'true');
        bg.decoding = 'async';
        bg.src = imgUrl(m.src, 64);
        var im = document.createElement('img');
        im.className = 'gqv__img';
        im.alt = m.alt || '';
        im.decoding = 'async';
        im.width = 1000;
        im.height = Math.round(1000 / (m.ar || 1));
        if (m.quick) {
          im.src = m.src;
        } else {
          im.sizes = '(min-width: 750px) 540px, 100vw';
          im.srcset = srcset(m.src, m.w);
          im.src = imgUrl(m.src, 900);
          if (i > 1) im.loading = 'lazy';
        }
        s.appendChild(bg);
        s.appendChild(im);
        track.appendChild(s);
        if (list.length > 1) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'gqv__dot';
          d.setAttribute('data-i', i);
          d.setAttribute('aria-label', T.imgOf(i + 1, list.length));
          dotsEl.appendChild(d);
        }
      });
      gal.classList.toggle('is-single', list.length < 2);
      track.scrollLeft = 0;
      slideIdx = -1;
      setSlide(0);
    }

    function fitGallery() {
      var w = track.clientWidth;
      var h = track.clientHeight;
      if (!w || !h) return;
      var box = w / h;
      var slides = track.children;
      for (var i = 0; i < slides.length; i++) {
        fitBox(slides[i], parseFloat(slides[i].getAttribute('data-ar')) || 1, box, 1.12);
      }
    }

    function setSlide(i) {
      var n = track.children.length;
      if (!n) return;
      i = Math.max(0, Math.min(n - 1, i));
      if (i === slideIdx) return;
      slideIdx = i;
      var dots = dotsEl.children;
      for (var k = 0; k < dots.length; k++) dots[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      prevB.disabled = i === 0;
      nextB.disabled = i === n - 1;
    }

    function goSlide(i, smooth) {
      var n = track.children.length;
      if (!n) return;
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !mqReduce.matches ? 'smooth' : 'auto' });
      setSlide(i);
    }

    /* ---------- Varianten ---------- */
    function onlyDefault(p) {
      return p.variants.length === 1 && (p.options.length === 0 || (p.options.length === 1 && /^default title$/i.test(p.variants[0].title)));
    }

    function buildOptions(p) {
      optsEl.innerHTML = '';
      if (onlyDefault(p)) return;
      p.options.forEach(function (opt, oi) {
        var name = typeof opt === 'string' ? opt : opt.name;
        var values = opt.values || [];
        var fs = document.createElement('fieldset');
        fs.className = 'gqv__opt';
        var lg = document.createElement('legend');
        lg.className = 'gqv__legend';
        var ln = document.createElement('span');
        ln.textContent = name + ':';
        var ls = document.createElement('span');
        ls.className = 'gqv__sel';
        lg.appendChild(ln);
        lg.appendChild(ls);
        fs.appendChild(lg);

        var imgs = values.map(function (val) {
          for (var k = 0; k < p.variants.length; k++) {
            var v = p.variants[k];
            if (v.options[oi] === val && v.featured_image) return v.featured_image.src;
          }
          return null;
        });
        var withImg = imgs.filter(Boolean);
        var uniq = {};
        withImg.forEach(function (s) {
          uniq[s] = 1;
        });
        var known = TILE_RX.test(name);
        var tiles =
          !SIZE_RX.test(name) &&
          values.length > 1 &&
          withImg.length > 0 &&
          withImg.length >= Math.ceil(values.length * (known ? 0.4 : 0.6)) &&
          (known || Object.keys(uniq).length > 1);

        var wrap = document.createElement('div');
        wrap.className = tiles ? 'gqv__tiles' : 'gqv__pills';
        values.forEach(function (val, vi) {
          var id = 'GqvO' + oi + '-' + vi;
          var input = document.createElement('input');
          input.type = 'radio';
          input.className = 'gqv__radio';
          input.name = 'gqv-o' + oi;
          input.id = id;
          input.value = val;
          input.setAttribute('data-oi', oi);
          var lab = document.createElement('label');
          lab.htmlFor = id;
          if (tiles) {
            lab.className = 'gqv__tile';
            var media = document.createElement('span');
            media.className = 'gqv__tmedia';
            if (imgs[vi]) {
              var im = document.createElement('img');
              im.alt = '';
              im.width = 160;
              im.height = 160;
              im.decoding = 'async';
              im.loading = vi < 12 ? 'eager' : 'lazy';
              im.src = imgUrl(imgs[vi], 240);
              im.srcset = imgUrl(imgs[vi], 160) + ' 160w, ' + imgUrl(imgs[vi], 240) + ' 240w, ' + imgUrl(imgs[vi], 360) + ' 360w';
              im.sizes = '(min-width: 750px) 110px, 26vw';
              media.appendChild(im);
            } else {
              media.classList.add('is-mono');
              media.setAttribute('data-mono', initials(val) || '•');
            }
            var nm = document.createElement('span');
            nm.className = 'gqv__tname';
            nm.textContent = val;
            var ck = document.createElement('span');
            ck.className = 'gqv__check';
            ck.setAttribute('aria-hidden', 'true');
            ck.innerHTML = SVG.check;
            lab.appendChild(media);
            lab.appendChild(nm);
            lab.appendChild(ck);
          } else {
            lab.className = 'gqv__pill';
            lab.textContent = val;
          }
          var outTxt = document.createElement('span');
          outTxt.className = 'visually-hidden gqv__outtxt';
          lab.appendChild(outTxt);
          wrap.appendChild(input);
          wrap.appendChild(lab);
        });
        fs.appendChild(wrap);
        optsEl.appendChild(fs);
      });
    }

    function findVariant(p, sel) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        var ok = true;
        for (var k = 0; k < sel.length; k++) {
          if (v.options[k] !== sel[k]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    function render(p) {
      st.product = p;
      titleEl.textContent = p.title;
      var first = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available) {
          first = p.variants[i];
          break;
        }
      }
      first = first || p.variants[0];
      st.sel = first ? first.options.slice() : [];
      buildOptions(p);
      buildGallery(mediaList(p));
      fitGallery();
      update(false);
    }

    function mediaIndex(id) {
      for (var i = 0; i < st.media.length; i++) if (String(st.media[i].id) === String(id)) return i;
      return -1;
    }

    function update(fromUser) {
      var p = st.product;
      var v = findVariant(p, st.sel);
      st.variant = v;
      /* Auswahl, gewählter Wert, Ausverkauft-Markierung */
      var sets = optsEl.querySelectorAll('.gqv__opt');
      for (var oi = 0; oi < sets.length; oi++) {
        var fs = sets[oi];
        var sel = fs.querySelector('.gqv__sel');
        if (sel) sel.textContent = st.sel[oi] || T.choose;
        var inputs = fs.querySelectorAll('.gqv__radio');
        for (var k = 0; k < inputs.length; k++) {
          var input = inputs[k];
          input.checked = input.value === st.sel[oi];
          var okAny = p.variants.some(function (vr) {
            if (!vr.available || vr.options[oi] !== input.value) return false;
            for (var j = 0; j < st.sel.length; j++) if (j !== oi && st.sel[j] != null && vr.options[j] !== st.sel[j]) return false;
            return true;
          });
          var lab = input.nextElementSibling;
          if (lab) {
            lab.classList.toggle('is-out', !okAny);
            var ot = lab.querySelector('.gqv__outtxt');
            if (ot) ot.textContent = okAny ? '' : ' – ' + T.out;
          }
        }
      }
      /* Preis (Mystery-Boxen / „kein-streichpreis“ ohne Streichpreis) */
      var price = v ? v.price : p.price;
      var cmp = v ? v.compare_at_price : p.compare_at_price;
      var html = '<span class="gqv__now">' + esc(st.money(price)) + '</span>';
      if (cmp && cmp > price && !noCompare(p)) {
        html += '<s class="gqv__was"><span class="visually-hidden">' + T.was + ' </span>' + esc(st.money(cmp)) + '</s>';
      }
      priceEl.innerHTML = html;
      /* Menge (Mengenregeln) */
      var rule = (v && v.quantity_rule) || {};
      st.qMin = Math.max(1, rule.min || 1);
      st.qMax = rule.max || 99;
      st.qStep = Math.max(1, rule.increment || 1);
      qtyIn.min = st.qMin;
      qtyIn.max = st.qMax;
      qtyIn.step = st.qStep;
      setQty(parseInt(qtyIn.value, 10) || st.qMin);
      /* Knopf */
      if (p.requires_selling_plan) setAdd('off', T.unavailable);
      else if (!v) setAdd('off', T.unavailable);
      else if (!v.available) setAdd('off', T.soldOut);
      else setAdd('on');
      if (fromUser) {
        msgEl.textContent = '';
        msgEl.classList.remove('is-err');
        if (v && v.featured_media) {
          var idx = mediaIndex(v.featured_media.id);
          if (idx > -1 && idx !== slideIdx) goSlide(idx, true);
        }
      }
    }

    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function setQty(n) {
      if (!st) return;
      var min = st.qMin || 1;
      var max = st.qMax || 99;
      var step = st.qStep || 1;
      if (!n || n < min) n = min;
      if (n > max) n = max;
      n = min + Math.round((n - min) / step) * step;
      if (n > max) n -= step;
      qtyIn.value = String(n);
      qMinus.disabled = n <= min;
      qPlus.disabled = n + step > max;
    }

    function stepQty(d) {
      setQty((parseInt(qtyIn.value, 10) || 1) + d * ((st && st.qStep) || 1));
    }

    function setAdd(mode, label) {
      addB.classList.remove('is-busy', 'is-done');
      if (mode === 'busy-init') {
        addB.disabled = true;
        addT.textContent = T.add;
        return;
      }
      if (mode === 'off') {
        addB.disabled = true;
        addT.textContent = label || T.unavailable;
        return;
      }
      if (mode === 'busy') {
        addB.disabled = false;
        addB.classList.add('is-busy');
        addB.setAttribute('aria-disabled', 'true');
        addT.textContent = T.adding;
        return;
      }
      if (mode === 'done') {
        addB.classList.add('is-done');
        addT.textContent = T.added;
        return;
      }
      addB.disabled = false;
      addB.removeAttribute('aria-disabled');
      addT.textContent = T.add;
    }

    function showMsg(text, err, linkHref, linkText) {
      msgEl.textContent = text;
      msgEl.classList.toggle('is-err', !!err);
      if (linkHref) {
        msgEl.appendChild(document.createTextNode(' '));
        var a = document.createElement('a');
        a.href = linkHref;
        a.textContent = linkText;
        msgEl.appendChild(a);
      }
    }

    /* ---------- In den Warenkorb ---------- */
    function submit() {
      if (!st || !st.variant || !st.variant.available || addB.classList.contains('is-busy') || addB.classList.contains('is-done')) return;
      var v = st.variant;
      var qty = parseInt(qtyIn.value, 10) || 1;
      var root = st.root;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: [{ id: v.id, quantity: qty }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) {
          return s.id;
        });
        body.sections_url = window.location.pathname;
      }
      var addUrl = ((window.routes && window.routes.cart_add_url) || root.getAttribute('data-add') || '/cart/add') + '.js';
      showMsg('');
      setAdd('busy');
      var my = st;
      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.json().then(
            function (d) {
              return { ok: r.ok, d: d };
            },
            function () {
              return { ok: r.ok, d: {} };
            }
          );
        })
        .then(function (res) {
          if (st !== my) return;
          var d = res.d || {};
          if (!res.ok || d.status) {
            setAdd('on');
            var t = d.description || d.message || T.error;
            showMsg(typeof t === 'string' ? t : T.error, true);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, { source: 'gop-quickview', productVariantId: v.id, errors: d.errors || d.description, message: d.message });
            }
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gop-quickview', productVariantId: v.id, cartData: d });
          }
          setAdd('done');
          var items = Array.isArray(d.items) ? d.items : [];
          var line = null;
          for (var i = 0; i < items.length; i++) if (items[i].variant_id === v.id) line = items[i];
          line = line || items[0] || {};
          if (cart && d.sections && typeof cart.renderContents === 'function') {
            /* wie Dawns Produktformular in der Schnellansicht: Fenster zu, dann Warenkorb-Hinweis des Themes */
            pendingCart = { cart: cart, state: Object.assign({}, line, { sections: d.sections }) };
            doneT = setTimeout(close, 900);
          } else {
            refreshBubble(root);
            showMsg(T.inCart, false, (window.routes && window.routes.cart_url) || root.getAttribute('data-cart') || '/cart', T.toCart);
            doneT = setTimeout(function () {
              if (st === my) setAdd('on');
            }, 2400);
          }
        })
        .catch(function () {
          if (st !== my) return;
          setAdd('on');
          showMsg(T.error, true);
        });
    }

    function showCart(pc, opener) {
      try {
        if (opener && typeof pc.cart.setActiveElement === 'function') pc.cart.setActiveElement(opener);
        pc.cart.renderContents(pc.state);
        pc.cart.classList.remove('is-empty');
      } catch (e) {
        refreshBubble(st && st.root);
      }
    }

    /* Zähler im Kopf neu laden (ohne Warenkorb-Element des Themes) */
    function refreshBubble(root) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      fetch(rootPath(root) + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          var html = d && d['cart-icon-bubble'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.querySelector('.shopify-section') || doc.body;
          bubble.innerHTML = sec.innerHTML;
        })
        .catch(function () {});
    }

    window.addEventListener('resize', function () {
      if (!isOpen) return;
      fitGallery();
      if (slideIdx > 0) track.scrollLeft = slideIdx * track.clientWidth;
    });

    return { open: open, close: close };
  })();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', function (e) {
    watch();
    scan(e.target);
  });
})();
